(()=>{
  const callbacks={analytics:new Set(),marketing:new Set()};
  let api=null,analytics=false,marketing=false,bannerPromise=null;
  const status=()=>document.querySelector('[data-iteraq-privacy-status]');
  function say(message){const e=status();if(e){e.hidden=!message;e.textContent=message;}}
  function refresh(){
    if(!api)return;
    const oldAnalytics=analytics,oldMarketing=marketing,choice=api.currentVisitorConsent();
    analytics=choice.analytics==='yes'&&api.analyticsProcessingAllowed();
    marketing=choice.marketing==='yes'&&api.marketingAllowed();
    document.documentElement.dataset.iteraqAnalytics=analytics?'allowed':'blocked';
    document.querySelectorAll('[data-iteraq-market-content]').forEach(e=>e.hidden=!analytics);
    document.querySelectorAll('[data-iteraq-market-notice]').forEach(e=>e.hidden=analytics);
    if((oldAnalytics&&!analytics)||(oldMarketing&&!marketing)){location.reload();return;}
    if(analytics)callbacks.analytics.forEach(fn=>fn());
    if(marketing)callbacks.marketing.forEach(fn=>fn());
  }
  function register(kind,fn){let loaded=false;const once=()=>{if(!loaded){loaded=true;fn();}};callbacks[kind].add(once);if(kind==='analytics'?analytics:marketing)once();}
  window.iteraqPrivacy={whenAnalytics:fn=>register('analytics',fn),whenMarketing:fn=>register('marketing',fn),analyticsAllowed:()=>analytics,marketingAllowed:()=>marketing};
  async function nativeBanner(){
    if(window.privacyBanner?.showPreferences)return window.privacyBanner;
    if(!bannerPromise)bannerPromise=new Promise((resolve,reject)=>{
      const src='https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      let script=document.querySelector('script[src="'+src+'"]');
      const done=()=>window.privacyBanner?.showPreferences?resolve(window.privacyBanner):reject(Error('Cookie settings unavailable'));
      const timer=setTimeout(()=>reject(Error('Cookie settings unavailable')),10000);
      const finish=()=>{clearTimeout(timer);done();};
      if(!script){script=document.createElement('script');script.src=src;script.async=true;script.addEventListener('load',finish,{once:true});script.addEventListener('error',()=>{clearTimeout(timer);reject(Error('Cookie settings unavailable'));},{once:true});document.head.append(script);}
      else{script.addEventListener('load',finish,{once:true});if(window.privacyBanner?.showPreferences)finish();}
    }).catch(error=>{bannerPromise=null;throw error;});
    return bannerPromise;
  }
  let opening=null;
  function showPreferences(){
    if(!opening)opening=(async()=>{
      const banner=await nativeBanner();
      for(const delay of [0,200,600,1200]){
        if(delay)await new Promise(resolve=>setTimeout(resolve,delay));
        await banner.showPreferences();
        const dialog=document.getElementById('shopify-pc__prefs__dialog');
        if(dialog&&!dialog.hidden&&getComputedStyle(dialog).display!=='none')return;
      }
      throw Error('Cookie preferences did not open');
    })().finally(()=>{opening=null;});
    return opening;
  }
  document.addEventListener('click',async event=>{
    const trigger=event.target.closest('[data-iteraq-cookie-settings]');if(!trigger)return;
    event.preventDefault();say('Opening cookie settings…');
    try{await showPreferences();say('');}catch{say('Cookie settings are temporarily unavailable. Optional market widgets remain off until consent is confirmed. Please retry.');}
  });
  function boot(){
    if(!window.Shopify?.loadFeatures){say('Optional market widgets are off. Cookie settings are temporarily unavailable.');return;}
    Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{
      if(error||!Shopify.customerPrivacy){say('Optional market widgets are off. Cookie settings are temporarily unavailable.');return;}
      api=Shopify.customerPrivacy;refresh();
    });
    document.addEventListener('visitorConsentCollected',refresh);
    const settings=document.querySelector('[data-iteraq-measurement]');if(settings?.dataset.enabled!=='true')return;
    const ga=settings.dataset.ga4,pixel=settings.dataset.meta;
    if(/^G-[A-Z0-9]+$/.test(ga||''))register('analytics',()=>{
      window.dataLayer=window.dataLayer||[];window.gtag=function(){dataLayer.push(arguments);};
      gtag('consent','default',{analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});gtag('consent','update',{analytics_storage:'granted'});gtag('js',new Date());gtag('config',ga,{allow_google_signals:false,allow_ad_personalization_signals:false});
      const script=document.createElement('script');script.async=true;script.src='https://www.googletagmanager.com/gtag/js?id='+encodeURIComponent(ga);document.head.append(script);
    });
    if(/^\d{5,20}$/.test(pixel||''))register('marketing',()=>{
      const fbq=window.fbq=function(){fbq.callMethod?fbq.callMethod.apply(fbq,arguments):fbq.queue.push(arguments);};fbq.queue=[];fbq.loaded=true;fbq.version='2.0';fbq('consent','grant');fbq('init',pixel);fbq('track','PageView');
      const script=document.createElement('script');script.async=true;script.src='https://connect.facebook.net/en_US/fbevents.js';document.head.append(script);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
